import { INavItemElement } from "./i-nav-item-element";

export class NavItem {
  public static SELECTOR = "[data-nav-item]";
  public static CLASSNAME_IS_ACTIVE = "is--active";
  private element: INavItemElement;
  private $regExp: RegExp;

  constructor(element: Element) {
    this.element = element as INavItemElement;
    this.onInit();
  }

  public get regExp(): RegExp {
    if (!this.$regExp) {
      this.$regExp = new RegExp(this.element.dataset.activeWhen, "g");
    }
    return this.$regExp;
  }

  public get currentPathname(): string {
    return window.location.pathname;
  }

  public onPathnameMatch() {
    this.element.classList.toggle(NavItem.CLASSNAME_IS_ACTIVE, true);
  }

  private onInit() {
    if (this.regExp.test(this.currentPathname)) {
      this.onPathnameMatch();
    }
  }
}



// WEBPACK FOOTER //
// ./components/nav-items/nav-item.ts